// extracted by mini-css-extract-plugin
export default {"SortedColumn":"SortedTableColumnSorter_SortedColumn__Dh9zh","SortingArrow":"SortedTableColumnSorter_SortingArrow__eITCg","Active":"SortedTableColumnSorter_Active__XxPB1"};